(function($) {
    $(document).ready(function() {
        var CLASS_HIDDEN = "hidden";
        var LIST_ELEMENT_VALUE_ATTR = "data-value";
        const searchResults = $(".search-results");

        if (searchResults) {

            const preselectedSortOption = $("#relevance");
            var preselectedSortOptionValue = $(preselectedSortOption).val();

            var currentTypeOption = $("div.resultTypesDropdown > button.dropdown-list-el");
            var dropdownMenu = $("div.dropdown-list");
            var sortMenu = $("div.sort-list");
            currentTypeOption.click(function(e) {
                if (dropdownMenu.hasClass(CLASS_HIDDEN)) {
                    dropdownMenu.removeClass(CLASS_HIDDEN);
                } else {
                    dropdownMenu.addClass(CLASS_HIDDEN);
                }
            });

            $(document).mousedown(function(e) {
                if (!currentTypeOption.is(e.target) &&
                    !dropdownMenu.is(e.target) &&
                    dropdownMenu.has(e.target).length === 0) {
                    dropdownMenu.addClass(CLASS_HIDDEN);
                }
            });

            const dropdownMenuOptions = dropdownMenu.find("button.dropdown-list-el");
            const sortMenuOptions = sortMenu.find("button.sort-list-el");

            dropdownMenuOptions.each(function(index, option) {
                $(this).click(function(e) {
                    const optionValue = $(e.target).attr(LIST_ELEMENT_VALUE_ATTR);
                    const optionText = $(e.target).text();

                    currentTypeOption.attr(LIST_ELEMENT_VALUE_ATTR, optionValue);
                    currentTypeOption.text(optionText);

                    const url = getResultsUrl(preselectedSortOptionValue, "", optionValue);
                    window.location = url;
                    dropdownMenu.addClass(CLASS_HIDDEN);
                });
            });

            sortMenuOptions.each(function(index, option) {
                $(this).click(function(e) {
                    const sortValue = $(e.target).attr(LIST_ELEMENT_VALUE_ATTR);
                    const sortText = $(e.target).text();
                    let url = "";

                    currentTypeOption.attr(LIST_ELEMENT_VALUE_ATTR, sortValue);
                    currentTypeOption.text(sortText);
                    if (getType(window.location.search)) {
                        url = getResultsUrl(sortValue, "", getType(window.location.search));
                    } else {
                        url = getResultsUrl(sortValue, "", "");
                    }

                    window.location = url;
                    dropdownMenu.addClass(CLASS_HIDDEN);
                });
            });

            const orderByOptions = $("input.multiple-choice");
            orderByOptions.each(function(index, value) {
                $(this).click(function(e) {
                    if (!$(this).attr("checked")) {
                        $(this).attr("checked", true);

                        const url = getResultsUrl($(this).val(),
                            "",
                            $(currentTypeOption).attr(LIST_ELEMENT_VALUE_ATTR));
                        window.location.search = url;
                    }
                });
            });
        }
    });

    $(".userSortDropdown").change(function(value) {
        const selectedValue = $(value.currentTarget).val();
        const url = getResultsUrl(selectedValue);
        window.location = url;
    });

    function getType(url) {
        const queryObject = JSON.parse('{"' +
            decodeURI(url.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') +
            '"}');

        return queryObject.type;
    }

    // Returns url with all needed parameters
    function getResultsUrl(orderBy, language, type) {
        const orderByFieldValue = $('[data-sf-role="searchResOrderBy"]').val();
        const orderByValue = orderBy || orderByFieldValue;
        const languageFieldValue = $('[data-sf-role="searchResLanguage"]').val();
        const languageValue = language || languageFieldValue;
        const typeFieldValue = "all";
        const typeValue = type || typeFieldValue;

        const orderByParam = orderByValue ? "&orderBy=" + orderByValue : "";
        const languageParam = languageValue ? "&language=" + languageValue : "";
        const typeParam = !typeValue || typeValue === "all" ? "" : "&type=" + typeValue;

        const indexCatalogueParam = $('[data-sf-role="searchResIndexCatalogue"]').val();
        const searchQueryParam = $('[data-sf-role="searchResQuery"]').val();
        const result =
            "?indexCatalogue=" + indexCatalogueParam + "&searchQuery=" + searchQueryParam + orderByParam + languageParam + typeParam;
        const currentPageUrl = $('[data-sf-role="currentPageUrl"]').val();

        return currentPageUrl + result;
    }
}(jQuery));